import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'usimweb-toggle',
    template: `
    <mat-slide-toggle [checked]="checked" [disabled]="disabled" [matTooltip]="tooltip" (change)="toggle($event)">
      {{ label }}
    </mat-slide-toggle>
  `,
    standalone: false
})
export class ToggleComponent {
  @Input() checked!: boolean;

  @Input() disabled!: boolean;

  @Input() label!: string;

  @Input() tooltip!: string;

  @Output() changes: EventEmitter<any> = new EventEmitter();

  public viewChanges(event: any) {
    this.changes.emit(event.value);
  }

  public toggle(event: any) {
    this.changes.emit(event);
  }
}
